export enum FecImportMappingTab {
  Journals = 'journals',
  ChartOfAccounts = 'chart_of_accounts',
  ThirdPartyAccounts = 'third_party_accounts',
}
